import React, { useEffect } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import stateApiService from '../services/StateApiService';
import { useHistory } from 'react-router';

const Disclaimer = (props) => {
    const history = useHistory();

    useEffect(() => {
      
    }, []);

    const onApplyNow = () =>{
        callPostState();
    }
    
    const callPostState = () => {
        
        
        let params = {
            packageId: '10000',  
            dataFields: '<Fields></Fields>'
        }
        stateApiService.postState(params).then(res => {
           
            let resData = res.data;
            if(resData.isSucess){
               history.push('sme/SampleMyInfo?StateId='+resData.model.stateId);
            }
        }).catch(err =>{   
        }) 
  
    }

    return(
        <div className="container mt-2">
        <div className="outerdivsubheader">
            <div className="row">
                <div className="col-12">
                    <h2 className='welcome mb-0'>FlexiBiz Account</h2>
                </div>
            </div>
        </div>
        <div className='DynaForm DynamicFields'>
            <div className='col-12'>
                <div className="panel-collapse collapse in">
                    <div className="panel-body">
                        <div className="row around-xs inputPair">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          
                                <p>The convenient way to opening your account...</p>
                                <div>
                                    <Button  className="btn btn-success mb-3" onClick={onApplyNow}>I WANT TO APPLY NOW</Button>
                                </div>
                                <div>
                                    <Button  className="btn k-secondary mb-3" >contact me for assistance</Button>
                                </div>
                       
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Disclaimer;